export const CTVipers = {
  id: "ctvipers",
  name: "CT Vipers",
  color: "#064E3B",
  lightColor: "#ECFDF5",
  logo: "🐍",

  teams: [
    { id: "snakeeyes", name: "Snake Eyes", level: "L2 Youth - D2" },
    { id: "medusa", name: "Medusa", level: "L2 Senior - D2" },
    { id: "misshiss", name: "Miss Hiss", level: "L1 Youth - D2 - Small" },
    { id: "phobia4", name: "Phobia4", level: "L4 Senior - D2" },
  ],

  schedule: [
    // --- SATURDAY ---
    {
      day: "Saturday",
      time: "11:11 AM",
      teamId: "phobia4",
      meet: "10:35 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "11:49 AM",
      teamId: "medusa",
      meet: "11:13 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:26 PM",
      teamId: "snakeeyes",
      meet: "12:50 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "3:33 PM",
      teamId: "misshiss",
      meet: "2:57 PM",
      panel: "Hall B",
    },

    // --- SUNDAY ---
    {
      day: "Sunday",
      time: "9:14 AM",
      teamId: "phobia4",
      meet: "8:38 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "10:06 AM",
      teamId: "medusa",
      meet: "9:30 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "11:09 AM",
      teamId: "snakeeyes",
      meet: "10:33 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "2:00 PM",
      teamId: "misshiss",
      meet: "1:24 PM",
      panel: "Hall B",
    },
  ],
};
